import { SelectOption } from '@globaleris/ui.library'
import moment from 'moment'
import {
  EnumCommodity,
  EnumEstadoCliente,
  EnumIdioma,
  EnumPais,
  EnumSubtipoSujeto,
  EnumTipoDocumentoFiscal,
  EnumTipoDocumentoIdentidad,
  EnumTipoResidencia,
  EnumTipoSujeto,
  EnumTipoSuministro,
  EnumZonaBalance
} from '../../api'
import { enumEnumToValueNumber, enumEnumToValueString, enumValueToKey } from '../../helpers'
import { hasResource } from '../../helpers/permissionsHelper'
import { Resources } from '../../model/RBAC/constants'
import { BalanceZoneStoreModel, CompanyStoreModel, getActiveCompany } from '../../redux'
// import { useTranslation } from "react-i18next";
// import { EnumCommodity } from "../../api";
// import { enumKeyToValue, enumToMapValues, enumValueToKey, MapToArray } from "../../helpers";
import { CommercialModel } from '../../api/Argentia/model/commercials/commercial'
import { ContractModel } from '../../api/Argentia/model/contracts'
import { EnumCommercialRelationActionType } from '../../api/oData/enums/enumCommercialRelationActionType'
import { EnumTipoNotificacion } from '../../api/oData/enums/enumTipoNotificacion'
import {
  ActiveContractsFilterModel,
  ClientGeneralDataFormModel,
  ContactInfoModel,
  FiscalAddressModel,
  IdentificationDocumentModel,
  LandingSubjectAnnouncementFilterModel,
  SubjectFilterModel,
  SubjectModel,
  SubjectTableModel
} from './clients.model'
import { CommercialTableModel } from './file/components/commercialsCard/commercialsCard.types'

// export const [t] = useTranslation(['translation']);

// export const commoditiesMapper = (items: EnumCommodity[]): EnumCommodity[] => {
//     return items && items.map(objectionItemMapper);
// };

// export const objectionItemMapper = (item: EnumCommodity): EnumCommodity => {

//     return (item);
// };

export const listIdDocumentItemMapper = (items: IdentificationDocumentModel[]): SelectOption[] => {
  return items && items.map(idDocumentItemMapper)
}

export const idDocumentItemMapper = (item: IdentificationDocumentModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.description
    }
  )
}

export const clientMapper = (
  clientFormData: ClientGeneralDataFormModel,
  activeCompany: CompanyStoreModel,
  balanceZone: BalanceZoneStoreModel
): SubjectModel => {
  const commodity: EnumCommodity | undefined =
    clientFormData.commodity! == EnumTipoSuministro.Gas
      ? EnumCommodity.GasNatural
      : clientFormData.commodity! == EnumTipoSuministro.Luz
        ? EnumCommodity.Electricidad
        : undefined

  return (
    clientFormData &&
    activeCompany &&
    balanceZone && {
      id: clientFormData.clientId,
      subtype: clientFormData.clientType!,
      commodityType: clientFormData.commodity!,
      commodity: commodity,
      personType: clientFormData.personType!,
      documentType: clientFormData.documentType!,
      documentID: clientFormData.documentId!,
      name: clientFormData.name!,
      surname1: clientFormData.surname1!,
      surname2: clientFormData.surname2!,
      businessName: clientFormData.businessName!,
      fiscalAddress: fiscalAddressMapper(clientFormData),
      contactInfo: contactInfoMapper(clientFormData),
      language: clientFormData.language!,
      residenceType: clientFormData.residenceType,
      nationality: clientFormData.nationality,
      companyID: activeCompany.id,
      balanceZone: enumValueToKey(EnumZonaBalance, balanceZone.id),
      clientCode: clientFormData.clientCode,
      erpCode: clientFormData.erpCode,
      state:
        clientFormData.state != null
          ? clientFormData.state
          : hasResource(Resources.ComunicationsCenterProcedures)
            ? EnumEstadoCliente.Borrador
            : EnumEstadoCliente.Activo,
      fatherSubject: { id: clientFormData.fatherSubjectId } as SubjectModel,
      removeFatherSubject: clientFormData.removeFatherSubject ?? false,
      updateFatherSubject: clientFormData.updateFatherSubject ?? false
    }
  )
}

export const mapSubjectToFileModel = (clientData: SubjectModel): any => {
  return (
    clientData && {
      clientName:
        clientData.businessName ??
        `${clientData.name} ${clientData.surname1} ${clientData.surname2}`,
      documentType:
        enumEnumToValueString(EnumTipoDocumentoIdentidad, clientData.documentType) ?? '',
      documentID: clientData.documentID,
      address: `${clientData.fiscalAddress.postalAddress}, ${clientData.fiscalAddress.municipality}, ${clientData.fiscalAddress.province}, ${clientData.fiscalAddress.country}`,
      subtype: enumEnumToValueString(EnumSubtipoSujeto, clientData.subtype) ?? '',
      state: enumEnumToValueString(EnumEstadoCliente, clientData.state) ?? '',
      code: (clientData.clientCode || clientData.erpCode) ?? '',

      contacts: clientData.contactInfo
    }
  )
}

export const subjectModelToClientGeneralDataFormModelMapper = (
  client: SubjectModel
): ClientGeneralDataFormModel => {
  const contactInfo = client.contactInfo.find(c => c.principal)

  return (
    client && {
      clientType: enumValueToKey(EnumSubtipoSujeto, client?.subtype),
      commodity: enumValueToKey(EnumTipoSuministro, client?.commodityType),
      personType: enumValueToKey(EnumTipoDocumentoFiscal, client?.personType),
      name: client.name,
      surname1: client.surname1,
      surname2: client.surname2,
      businessName: client.businessName,
      documentType: enumValueToKey(EnumTipoDocumentoIdentidad, client?.documentType),
      documentId: client.documentID,
      postalAddress: client.fiscalAddress?.postalAddress,
      postalCode: client.fiscalAddress?.postalCode,

      municipalityId: client.fiscalAddress?.municipalityId,
      provinceId: client.fiscalAddress?.provinceId,
      countryId: client.fiscalAddress?.countryId,
      municipality: client.fiscalAddress?.municipality,
      province: client.fiscalAddress?.province,
      country: client.fiscalAddress?.country,
      email: contactInfo?.email,
      phoneNumber: contactInfo?.phoneNumber,
      language: enumValueToKey(EnumIdioma, client.language),
      notifications: contactInfo?.notificationType
        ? enumValueToKey(EnumTipoNotificacion, contactInfo?.notificationType)
        : contactInfo?.notificationType,
      nationality: enumValueToKey(EnumPais, client.nationality),
      residenceType: enumValueToKey(EnumTipoResidencia, client.residenceType),
      contractId: contactInfo?.contractId,
      additionalInfo: contactInfo?.comments,
      clientCode: client.clientCode,
      erpCode: client.erpCode,
      state: enumEnumToValueNumber(EnumEstadoCliente, client.state),
      fatherSubjectId: client.fatherSubject?.id
    }
  )
}

export const fiscalAddressMapper = (
  clientFormData: ClientGeneralDataFormModel
): FiscalAddressModel => {
  return (
    clientFormData && {
      Id: clientFormData.fiscalAddressId,
      postalAddress: clientFormData.postalAddress!,
      postalCode: clientFormData.postalCode!,
      municipality: clientFormData.municipality!,
      province: clientFormData.province!,
      country: clientFormData.country!,
      municipalityId: clientFormData.municipalityId,
      provinceId: clientFormData.provinceId,
      countryId: clientFormData.countryId
    }
  )
}

export const contactInfoMapper = (
  clientFormData: ClientGeneralDataFormModel
): ContactInfoModel[] => {
  return (
    clientFormData && [
      {
        id: clientFormData.contactInfoId,
        contactName:
          clientFormData.name !== undefined
            ? clientFormData.name!.concat(' ', clientFormData.surname1!)
            : clientFormData.businessName!,
        email: clientFormData.email!,
        phoneNumber: clientFormData.phoneNumber!,
        notificationType: clientFormData.notifications!,
        principal: true,
        contractId: clientFormData.contractId,
        comments: clientFormData.additionalInfo
      }
    ]
  )
}

export const subjectFilterMapper = (
  search: string,
  subjectTypeList: EnumTipoSujeto[],
  isActive: boolean,
  commodity?: EnumCommodity
): SubjectFilterModel => {
  const activeCompany = getActiveCompany()?.id
  return {
    searchText: search,
    companyID: activeCompany!,
    isActive: isActive,
    subjectTypeList: subjectTypeList
  }
}

export const subjectsListMapper = (items: SubjectTableModel[]): SelectOption[] => {
  return items && items.map(subjectItemMapper)
}

export const subjectItemMapper = (item: SubjectTableModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.description
    }
  )
}

export const landingSubjectAnnouncementFilterMapper = (
  subjectTypes: EnumTipoSujeto[],
  subjectStates: EnumEstadoCliente[],
  commodity?: EnumCommodity
): LandingSubjectAnnouncementFilterModel => {
  const activeCompany = getActiveCompany()?.id
  return {
    subjectTypes: subjectTypes,
    subjectStates: subjectStates,
    companyID: activeCompany!,
    commodity: commodity
  }
}

export const landingSubjectKpisFilterMapper = (
  subjectTypes: EnumTipoSujeto[],
  commodity?: EnumCommodity
): ActiveContractsFilterModel => {
  const activeCompany = getActiveCompany()?.id
  return {
    date: moment(new Date()).add(0, 'days').toDate(),
    subjectTypes: subjectTypes,
    companyID: activeCompany!,
    commodity: commodity
  }
}

export const contractsListMapper = (
  contracts: ContractModel[] | undefined
): ContractModel[] | undefined => {
  return contracts
    ? contracts.map(contract => {
        const contractStatus = enumEnumToValueNumber(EnumEstadoCliente, contract.status)
        const canActivate = contractStatus === EnumEstadoCliente.Borrador
        const canTerminate =
          contractStatus === EnumEstadoCliente.Borrador ||
          contractStatus === EnumEstadoCliente.Rechazado ||
          contractStatus === EnumEstadoCliente.Activo ||
          contractStatus === EnumEstadoCliente.Anulado ||
          contractStatus === EnumEstadoCliente.BajaTemporal ||
          contractStatus === EnumEstadoCliente.Cortado
        const uniqueCUPS =
          contract.cupsList && contract.cupsList.length > 0
            ? [...new Set(contract.cupsList?.map(c => c.code))]
            : null
        return {
          ...contract,
          canActivate,
          canTerminate,
          cupsListFormatted: uniqueCUPS ? uniqueCUPS.join(', ') : ''
        }
      })
    : contracts
}

export const contractModelToFlexibilityOptionsMapper = (
  contracts: ContractModel[]
): SelectOption[] => {
  return contracts
    .filter(contract => contract.hasFlexibilities)
    .map(contract => ({ value: contract.id, label: contract.contractCode }))
}

export const commercialsToTableModelMapper = (
  commercials: CommercialModel[] | undefined
): CommercialTableModel[] | undefined => {
  return commercials
    ? commercials.map(commercial => {
        let relatedProductDesc: string
        switch (enumEnumToValueNumber(EnumCommercialRelationActionType, commercial.relationLevel)) {
          case EnumCommercialRelationActionType.Subject: {
            relatedProductDesc = 'Todos los contratos'
            break
          }
          case EnumCommercialRelationActionType.Contract: {
            relatedProductDesc = 'Contrato ' + commercial.contractDesc
            break
          }
          case EnumCommercialRelationActionType.Product: {
            relatedProductDesc =
              commercial.contractProductDesc && commercial.contractDesc
                ? 'Producto ' +
                  (commercial.contractProductDesc ?? '') +
                  ' de Contrato ' +
                  commercial.contractDesc
                : ''
            break
          }
          case EnumCommercialRelationActionType.Trade: {
            relatedProductDesc = 'Trade ' + commercial.tradeId
            break
          }
          default: {
            relatedProductDesc = ''
          }
        }
        return {
          ...commercial,
          relationLevel: enumEnumToValueNumber(
            EnumCommercialRelationActionType,
            commercial.relationLevel
          )!,
          relatedProductDesc
        }
      })
    : commercials
}
